(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canelita-instagram"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShoppable(wrap) {
      var buttons = wrap.querySelectorAll('.ig-hotspot');
      var cards   = wrap.querySelectorAll('.ig-hotspot-card');

      function closeAll() {
        buttons.forEach(function(b) { b.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); });
        cards.forEach(function(c) { c.classList.remove('is-visible'); c.setAttribute('aria-hidden', 'true'); });
      }

      buttons.forEach(function(btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          var id   = btn.dataset.hotspot;
          var card = wrap.querySelector('#hc-' + id);
          var open = btn.classList.contains('is-open');
          closeAll();
          if (!open && card) {
            btn.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            card.classList.add('is-visible');
            card.setAttribute('aria-hidden', 'false');
          }
        });
      });

      document.addEventListener('click', function(e) {
        if (!wrap.contains(e.target)) closeAll();
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeAll();
      });
    }

    document.querySelectorAll('[id^="shoppable-"]').forEach(initShoppable);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
